/* eslint-disable */
import React, { Component } from "react";
import InputRange from "react-input-range";
import "./ActivityListing.css";
import {
  PackageZoneData,
  getPackageCategory,
  getTourFilterPackagePlan,
  getTourPackagePlanlist
} from "../Component/axios";
import Autosuggest from "react-autosuggest";
import NewHeader from "../Component/NewHeader/NewHeader";
import moment from "moment";
import { Helmet } from "react-helmet";
import "react-google-flight-datepicker/dist/main.css";
import DayPicker from "react-day-picker";
import "react-day-picker/lib/style.css";
import HotelListSkeleton from "../Component/HostelList/HotelListSkeleton";
import TourPackageList from "../TourList/TourPackageList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEuroSign,
} from "@fortawesome/free-solid-svg-icons";
import Skeleton from "react-loading-skeleton";
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
// import ExperiencesSoldout from "./SoldOut/ExperiencesSoldout";
import TawkToWidget from "../Component/TawkToWidget";
import EmptyRowComponent from "../Component/AdminPackageDetails/PackageShowcase/EmptyRowComponent";

const SortArr = [
  { id: "4", name: "Recommended" },
  { id: "1", name: "Price - Low to High" },
  { id: "2", name: "Price - High to Low" },
  // { id: "3", name: "User Rating - High to Low" },
];

export default class PackageListing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: null,
      endDate: null,
      error: null,
      nav: false,
      sorting: false,
      sortingSelect: "Recommended",
      isDropdownOpen: false,
      value: "",
      suggestionsPackage: [],
      showResultsPackage: false,
      defaultZonevalPackage: "Mahe Island",
      selectPackageDay: moment(new Date()).format("ddd, D MMM yy"),
      selectPackageDayNew: new Date(),
      checkinShowPackage: false,
      packageData: null,
      FiltersData: null,
      valuePrice: { min: 0, max: 10 },
      durationFilterValue: { min: 0, max: 7 },
      appliedFilterVal: [],
      checked: false,
      checkedItems: new Map(),
      packageList: null,
      packageListFilter: null,
      checkedTime: false,
      checked: [],
      expanded: [],
      categoryData: [],
      selectedCategories: [],
    };
  }

  callFilterAPI(zone, date) {
    const prepareData = {
      defaultZonevalVal: zone,
      dateSelected: moment(date).format("Y-MM-DD"),
    };

    getTourFilterPackagePlan(prepareData).then(
      (data) => {
        this.setState({
          FiltersData: data,
          valuePrice: { min: parseFloat(data?.min_price ?? 0).toFixed(2), max: parseFloat(data?.max_price ?? 0).toFixed(2) },
          durationFilterValue: { min: parseInt(data?.min_night ?? 0), max: parseInt(data?.max_night ?? 0) }
        })
      },
      (error) => {
        this.setState({ error });
      }
    );
  }

  async callPackageListingAPI(location, date) {
    this.setState({
      packageData: null,
    });
    const { selectedCategories } = this.state; // Get selected categories from state
    const categoryId = selectedCategories.length > 0 ? selectedCategories.join(",") : "";

    const JsonState = {
      defaultZonevalPackageVal: location,
      dateSelected: moment(date).format("Y-MM-DD"),
      privacy_type: 3,
      category_id: categoryId,
    };

    await getTourPackagePlanlist(JSON.stringify(JsonState)).then(
      (data) => {
        if (data == undefined) {
          this.setState({
            packageData: null,
          });
        } else {
          this.setState({
            packageListFilter: data,
          });

          if (data == "no_package") {
            this.setState({
              packageData: data,
            });
          } else {
            this.SortingFunction(data);
          }
        }
      },
      (error) => {
        this.setState({
          error,
        });
      }
    );
  }

  componentDidMount() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const defaultZonevalPackageVal = urlParams.get("defaultZonevalPackageVal");
    const dateSelected = urlParams.get("dateSelected");

    this.setState({
      defaultZonevalPackage: defaultZonevalPackageVal,
      selectPackageDayNew: dateSelected,
      selectPackageDay: moment(dateSelected).format("ddd, D MMM yy"),
    });

    PackageZoneData().then(
      (data) => {
        this.setState({
          itemsZonePackage: data,
        });
      },
      (error) => {
        this.setState({ error });
      }
    );

    getPackageCategory().then(
      (data) => {
        if (Array.isArray(data) && data.length) {
          this.setState({
            categoryData: data,
          });
        }
      },
      (error) => {
        this.setState({ error });
      }
    );

    this.callPackageListingAPI(defaultZonevalPackageVal, dateSelected);
    this.callFilterAPI(defaultZonevalPackageVal, dateSelected);
    window.addEventListener("scroll", this.handleScroll);
  }

  SearchListing = () => {
    this.setState({
      FiltersData: null,
    });
    this.setState({
      packageData: null,
    });
    this.setState({
      sortingSelect: "Recommended",
    });

    let JsonState = {
      defaultZonevalPackageVal: this.state.defaultZonevalPackage,
      dateSelected: moment(this.state.selectPackageDayNew).format("Y-MM-DD"),
      privacy_type: 3,
      category_id: "",
    };
    const hotelArr = JSON.stringify(JsonState);

    getTourPackagePlanlist(hotelArr).then(
      (data) => {
        if (data == undefined) {
          this.setState({
            packageData: null,
          });
        } else {
          this.setState({
            packageListFilter: data,
          });

          if (data == "no_package") {
            this.setState({
              packageData: data,
            });
          } else {
            this.SortingFunction(data);
          }
        }
      },
      (error) => {
        this.setState({
          error,
        });
      }
    );
    this.callFilterAPI(this.state.defaultZonevalPackage, this.state.selectPackageDayNew);
  };

  SortingFunction = (data) => {
    if (data != "no_package") {
      const sorArr = data;

      setTimeout(() => {
        this.setState({
          packageData: sorArr,
        });
        this.setState({ packageListFilter: sorArr });
      }, 2000);
    }
  };

  sortingSearch = (data) => {

    const sorArr = data;
    if (this.state.sortingSelect == "Price - Low to High") {

      setTimeout(() => {
        const getValue = (price) => +price;
        sorArr.sort((a, b) =>
          getValue(a.selling_price) - getValue(b.selling_price)
        );

        this.setState({
          packageData: sorArr,
          packageListFilter: sorArr
        });
      }, 2000);
    } else if (this.state.sortingSelect == "Price - High to Low") {
      setTimeout(() => {
        const getValue = (price) => -price;

        sorArr.sort((a, b) =>
          getValue(a.selling_price) - getValue(b.selling_price)
        );

        this.setState({
          packageData: sorArr,
          packageListFilter: sorArr
        });
      }, 1000);
    } else if (this.state.sortingSelect == "Recommended") {
      setTimeout(() => {
        const getValue = (price) => price;
        sorArr.sort((a, b) =>
          getValue(a.selling_price) - getValue(b.selling_price)
        );
        this.setState({
          activityData: sorArr,
          packageListFilter: sorArr
        });
      }, 1000);
    }
  };

  componentWillUnmount() {
    window.removeEventListener("click", this.globalClickListener);
    window.removeEventListener("scroll", this.handleScroll);
  }

  globalClickListener = (nativeEvent) => {
    this.setState(
      {
        isDropdownOpen: false,
        showResultsPackage: false,
        checkinShowPackage: false,
      },
      () => {

        // document.removeEventListener('click', this.globalClickListener)
        window.removeEventListener("click", this.globalClickListener);
      }
    );
  };

  checkinandcheckoutPackage = (syntheticEvent) => {
    this.setState({ showResultsPackage: false });
    syntheticEvent.stopPropagation();
    this.setState(
      (prevState) => ({ checkinShowPackage: !prevState.checkinShowPackage }),
      () => {
        if (this.state.checkinShowPackage) {
          window.addEventListener("click", this.globalClickListener);
        }
      }
    );
  };

  handleBodyClick = (event) => {
    event.stopPropagation();
  };

  showSorting = (syntheticEvent) => {
    syntheticEvent.stopPropagation();
    this.setState((prevState) => ({
      isDropdownOpen: !prevState.isDropdownOpen,
    }));
    this.setState(
      (prevState) => ({ sorting: !prevState.sorting }),
      () => {
        if (this.state.sorting) {
          window.addEventListener("click", this.globalClickListener);
        }
      }
    );
  };

  getSuggestionsPackage = (value) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    return inputLength === 0
      ? []
      : this.state.itemsZonePackage.filter(
        (lang) => lang.Name.toLowerCase().slice(0, inputLength) === inputValue
      );
  };

  onSuggestionsFetchRequestedPackage = ({ value }) => {
    this.setState({
      suggestionsPackage: this.getSuggestionsPackage(value),
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequestedPackage = () => {
    this.setState({
      suggestionsPackage: [],
    });
  };

  onSuggestionSelectedPackage = () => {
    this.setState({
      showResultsPackage: false,
    });
  };

  getSuggestionValuePackage = (suggestion) => suggestion.Name;

  // Use your imagination to render suggestions.
  getSuggestionValuePackage = (suggestion) => suggestion.Name;

  // Use your imagination to render suggestions.
  renderSuggestionPackage = (suggestion, { query, isHighlighted }) => (
    <div className="font14 darkText  noChild  clickable">
      <div className="hsFlexspaceBetween hsFlex hrtlCenter ">
        {suggestion.LocationImage != "nolocation" ? (
          <div className="locationImageLocation">
            <img
              src="images/locationacco.png"
              className="locationImageContent"
            />
          </div>
        ) : (
          <div className="tourImage">
            {" "}
            <img src={suggestion.Image} className="locationImageContent2" />
          </div>
        )}
        <div className="flexOne">
          <p className="locusLabel appendBottom5 fontSizeChange">
            {suggestion.Name}
          </p>
        </div>
      </div>
    </div>
  );

  renderSuggestionsContainerPackage = ({ containerProps, children, query }) => {
    return (
      <div {...containerProps}>
        <div className="react-autosuggest__section-title">
          <label className="hsw_sectionTitle font12 latoBlack greyText">
            Suggestions{" "}
          </label>
        </div>
        {query.length === 0 ? (
          <div>
            <ul role="listbox" className="react-autosuggest__suggestions-list">
              <li
                role="option"
                id="react-autowhatever-1-section-1-item-0"
                aria-selected="false"
                className="react-autosuggest__suggestion react-autosuggest__suggestion--first"
                data-section-index="1"
                data-suggestion-index="0"
              >
                <div className="font14 darkText  noChild  clickable" onClick={() => this.handleChangeSuggetionPackage("Mahe Island")}>
                  <div className="hsFlexspaceBetween hsFlex hrtlCenter ">
                    <div className="locationImageLocation">
                      <img src="images/locationacco.png" className="locationImageContent" />
                    </div>
                    <div className="flexOne">
                      <p className="locusLabel appendBottom5 fontSizeChange">
                        Mahe Island
                      </p>
                    </div>
                  </div>
                </div>
              </li>
              <li
                role="option"
                id="react-autowhatever-1-section-1-item-0"
                aria-selected="false"
                className="react-autosuggest__suggestion react-autosuggest__suggestion--first"
                data-section-index="1"
                data-suggestion-index="0"
              >
                <div className="font14 darkText  noChild  clickable" onClick={() => this.handleChangeSuggetionPackage("Praslin Island")}>
                  <div className="hsFlexspaceBetween hsFlex hrtlCenter ">

                    <div className="locationImageLocation">
                      <img
                        src="images/locationacco.png"
                        className="locationImageContent"
                      />
                    </div>

                    <div className="flexOne">
                      <p className="locusLabel appendBottom5 fontSizeChange">
                        Praslin Island
                      </p>
                    </div>
                  </div>
                </div>
              </li>
              <li
                role="option"
                id="react-autowhatever-1-section-1-item-0"
                aria-selected="false"
                className="react-autosuggest__suggestion react-autosuggest__suggestion--first"
                data-section-index="1"
                data-suggestion-index="0"
              >
                <div className="font14 darkText  noChild  clickable" onClick={() => this.handleChangeSuggetionPackage("La Digue Island")}>
                  <div className="hsFlexspaceBetween hsFlex hrtlCenter ">
                    <div className="locationImageLocation">
                      <img src="images/locationacco.png" className="locationImageContent" />
                    </div>
                    <div className="flexOne">
                      <p className="locusLabel appendBottom5 fontSizeChange">
                        La Digue Island
                      </p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        ) : (
          <div> {children}</div>
        )}
      </div>
    );
  };

  showZonelistdivPackage = (syntheticEvent) => {
    this.setState({ checkinShowPackage: false });
    syntheticEvent.stopPropagation();
    this.setState(
      (prevState) => ({ showResultsPackage: !prevState.showResultsPackage }),
      () => {
        if (this.state.showResultsPackage) {
          // document.addEventListener('click', this.globalClickListener)
          window.addEventListener("click", this.globalClickListener);
        }
      }
    );
  };

  onChangePackage = (event, { newValue }) => {
    this.setState({
      value: newValue,
      defaultZonevalPackage: newValue,
    });
  };

  handleChangeSuggetionPackage = (newValue) => {
    this.setState({
      value: newValue,
      defaultZonevalPackage: newValue,
    });
    this.setState({
      showResultsActivity: false,
    });
  };

  handlePackageDayClick = (day, { selected, disabled }) => {
    if (disabled) {
      // If the day is disabled, do nothing
      return;
    }
    this.setState({ selectPackageDayNew: selected ? undefined : day });
    this.setState({ selectPackageDay: moment(day).format("ddd, D MMM yy") });
    this.setState({ checkinShowPackage: false });
  };

  handleScroll = () => {
    if (window.pageYOffset > 10) {
      if (!this.state.nav) {
        this.setState({ nav: true });
      }
    } else {
      if (this.state.nav) {
        this.setState({ nav: false });
      }
    }
  };

  handleSortingChange = (e) => {
    this.setState({ isDropdownOpen: false });
    this.setState({
      packageData: null,
    });

    const sorArr = this.state.packageData;

    if (e.id == 2) {
      setTimeout(() => {
        const getValue = (price) => -price;

        sorArr.sort(
          (a, b) =>
            getValue(a.selling_price) - getValue(b.selling_price)
        );

        this.setState({
          packageData: sorArr,
        });
      }, 1000);
    } else if (e.id == 3) {
      setTimeout(() => {
        const getValue = (star) => -star;
        sorArr.sort((a, b) => getValue() - getValue());

        this.setState({
          packageData: sorArr,
        });
      }, 1000);
    } else if (e.id == 1) {
      setTimeout(() => {
        const getValue = (price) => +price;
        sorArr.sort(
          (a, b) =>
            getValue(a.selling_price) - getValue(b.selling_price)
        );

        this.setState({
          packageData: sorArr,
        });
      }, 1000);
    } else if (e.id == 4) {
      setTimeout(() => {
        const getValue = (id) => id;
        sorArr.sort(
          (a, b) =>
            getValue(a.selling_price) - getValue(b.selling_price)
        );

        this.setState({
          packageData: sorArr,
        });
      }, 1000);
    }

    this.setState({
      sortingSelect: e.name,
    });
  };

  changePrice = (value) => {
    this.setState({ packageData: null });

    let name = value.min + "-" + value.max;
    let applied = [...this.state.appliedFilterVal];

    let PriceRangeVal = "abc";

    applied.map((i, j) => {
      if (i.value == "priceRange") {
        PriceRangeVal = j;
        return PriceRangeVal;
      }
    });

    if (PriceRangeVal == "abc") {
      this.setState({
        appliedFilterVal: [...applied, { label: name, value: "priceRange" }],
      });
    } else {
      applied[PriceRangeVal] = { label: name, value: "priceRange" };
      this.setState({
        appliedFilterVal: applied,
      });
    }

    const packagedData = [...this.state.packageListFilter];

    const result = [];

    packagedData.map((i) => {
      {
        if (
          parseFloat(i.selling_price) >= value.min &&
          parseFloat(i.selling_price) <= value.max
        ) {
          result.push(i);
        }
      }
    });

    setTimeout(() => {
      this.setState({ packageData: result });
    }, 1000);
  };

  changeDuration = (value) => {
    this.setState({ packageData: null });

    const packagedData = [...this.state.packageListFilter];

    const result = [];

    packagedData.map((i) => {
      {
        if (
          parseInt(i.no_days) >= value.min &&
          parseInt(i.no_days) <= value.max
        ) {
          result.push(i);
        }
      }
    });

    setTimeout(() => {
      this.setState({ packageData: result });
    }, 1000);
  };

  RemoveSingleFilter = (i, index, maxValue) => {
    this.setState({ packageData: null });

    let applied = [...this.state.appliedFilterVal];

    applied.splice(index, 1);

    this.setState({
      appliedFilterVal: applied,
    });

    document.getElementsByName(i.label).checked = false;

    this.setState((prevState) => prevState.checkedItems.set(i.label, false));

    let PriceRange = { min: 0, max: maxValue };

    this.setState({ valuePrice: PriceRange });

    const packagedData = [...this.state.packageListFilter];

    const result = [];

    setTimeout(() => {
      packagedData && packagedData.map((i, j) => {
        if (i != "no_package") {
          Object.values(i).map((key1, index) => {
            if (this.state.appliedFilterVal.length > 0) {
              this.state.appliedFilterVal.map((item, index) => {

                if (this.state.defaultZonevalPackage.toLowerCase().trim() === 'seychelles') {
                  if (key1.tour_data.tour_region_name.toLowerCase().trim() === item.label) {
                    result.push(i);
                  }
                } else {
                  if (key1.tour_data.tour_location.toLowerCase().trim() === item.label) {
                    result.push(i);
                  }
                }
              });
            }
          });
        }
      });
    }, 1000);

    setTimeout(() => {
      this.setState({ packageData: result });
    }, 1000);

    setTimeout(() => {
      if (this.state.appliedFilterVal.length == 0) {
        this.setState({ packageData: packagedData });
      }
    }, 1000);
  };

  RemoveMultipleFilter = (maxValue) => {
    this.setState({ packageData: null });
    this.setState({
      appliedFilterVal: [],
    });
    this.setState({ liveaboardList: null });
    let PriceRange = { min: 0, max: maxValue };

    this.setState({ valuePrice: PriceRange });

    const clearCheckedItems = new Map();
    this.setState({ checkedItems: clearCheckedItems });

    const packagedData = [...this.state.packageListFilter];

    setTimeout(() => {
      this.setState({ packageData: packagedData });
    }, 1000);
  };

  handleCheckboxChange = (id) => {
    this.setState((prevState) => {
      const isAlreadySelected = prevState.selectedCategories.includes(id);
      return {
        selectedCategories: isAlreadySelected
          ? prevState.selectedCategories.filter((catId) => catId !== id) // Uncheck
          : [...prevState.selectedCategories, id], // Check
      };
    },
      () => {
        this.callPackageListingAPI(this.state.defaultZonevalPackage, this.state.selectPackageDayNew);
      });
  };

  render() {
    const { value, suggestionsPackage } = this.state;

    const inputPropsPackage = {
      placeholder: "Enter location or package name",
      type: "search",
      value,
      onChange: this.onChangePackage,
    };
    return (
      <React.Fragment>
        <div>
          <Helmet>
            <title>Best packages in Seychelles- Holidays Seychelles</title>
            <meta name="description" content="Get best booking rates and packages for beautiful attractions in Seychelles." />
            <meta name="keywords" content="Seychelles, Seychellen, best place for honeymoon,most beautiful places in the world,best honeymoon destination in the world,honeymoon places,honeymoon destinations,beautiful places in the world" />
          </Helmet>
          <h1 style={{ color: '#fff' }}>Best packages in Seychelles- Holidays Seychelles</h1>
          <NewHeader page={"inner_listing"} tabName={3} />
          <div
            className={`${this.state.nav == true
              ? "_Hlisting_header_new"
              : "_Hlisting_header"
              }`}
          >
            <div className="container hsw">
              <div className="hsw_inner">
                <div
                  className="hsw_inputBoxActivity  "
                  onClick={this.showZonelistdivPackage}
                >
                  <label
                    for="city"
                    className="lbl_input latoBold font12 blueText"
                  >
                    Location or package name
                  </label>
                  <p
                    className="hsw_inputField font16 whiteText"
                    style={{ marginBottom: "3px" }}
                  >
                    {this.state.defaultZonevalPackage.length >= 50
                      ? `${this.state.defaultZonevalPackage.substring(
                        0,
                        50
                      )}...`
                      : this.state.defaultZonevalPackage}
                  </p>
                  <div className="focused_div">
                    {this.state.showResultsPackage ? (
                      <div
                        className="autocomplete-wrapper"
                        style={{ top: 30 }}
                        onClick={this.handleBodyClick}
                      >
                        <Autosuggest
                          suggestions={suggestionsPackage}
                          onSuggestionsFetchRequested={
                            this.onSuggestionsFetchRequestedPackage
                          }
                          onSuggestionSelected={
                            this.onSuggestionSelectedPackage
                          }
                          onSuggestionsClearRequested={
                            this.onSuggestionsClearRequestedPackage
                          }
                          getSuggestionValue={this.getSuggestionValuePackage}
                          renderSuggestionsContainer={
                            this.renderSuggestionsContainerPackage
                          }
                          renderSuggestion={this.renderSuggestionPackage}
                          inputProps={inputPropsPackage}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
                <div
                  className="hsw_inputBoxActivity"
                  onClick={this.checkinandcheckoutPackage}
                >
                  <span className="checkinandcheckout">
                    <label
                      for="checkin"
                      className="lbl_input latoBold font12 blueText capText"
                    >
                      Add when you want to go
                    </label>
                  </span>
                  <p className="hsw_inputField font16 whiteText">
                    {this.state.selectPackageDay}
                  </p>
                  <div onClick={this.handleBodyClick}>
                    {this.state.checkinShowPackage && (
                      <DayPicker
                        className="activityDate"
                        onDayClick={this.handlePackageDayClick}
                        selectedDays={this.state.selectPackageDayNew}
                        disabledDays={{ before: new Date() }}
                        month={new Date()} // Ensure the current month is displayed initially
                        fromMonth={new Date()} // Disable navigation to months before today
                      />
                    )}
                  </div>
                </div>
                <span
                  className="primaryBtn hsw_searchButton"
                  onClick={this.SearchListing}
                >
                  Search
                </span>
              </div>
            </div>
          </div>

          <div className="container makeFlex spaceBetween">
            <div
              className="container makeFlex spaceBetween"
              style={{ marginTop: 50, padding: "10px" }}
            >
              {this.state.FiltersData == null ? (
                <>
                  <div className="filterWrap appendRight30">
                    {Array.from({ length: 1 }, (_, index) => index).map((_, index) =>
                      <div
                        key={index}
                        className="filterRow"
                        id="hlistpg_fr_star_category"
                      >
                        <div className="latoBold font16 blackText appendBottom15 makeFlex hrtlCenter">
                          <Skeleton style={{ width: 240, height: 26 }} />
                        </div>
                        <ul className="filterList">
                          {
                            Array.from({ length: 6 }, (_, index) => index).map((_, index) =>
                              <li key={index}>
                                <label>
                                  <Skeleton style={{ width: 20, height: 20 }} />
                                  <Skeleton
                                    style={{
                                      width: 190,
                                      height: 15,
                                      marginLeft: 10,
                                    }}
                                  />
                                </label>
                              </li>
                            )
                          }
                        </ul>
                      </div>
                    )}
                  </div>
                </>
              ) : this.state.FiltersData == "no_package" ? (
                <></>
              ) : (
                <div className="filterWrap appendRight30">
                  {this.state.appliedFilterVal.length > 0 ? (
                    <div className="appliedFiltersContainer">
                      <div
                        className="makeFlex spaceBetween end appendBottom20"
                        style={{
                          marginBottom: 10,
                          justifyContent: "space-between",
                        }}
                      >
                        <span className="font20 blackText">
                          Applied Filters
                        </span>
                        <a
                          className="latoBold font12 capText"
                          href="javascript:;"
                          onClick={() =>
                            this.RemoveMultipleFilter(
                              this.state.FiltersData.max_price
                            )
                          }
                        >
                          Clear
                        </a>
                      </div>
                      <ul className="appliedFilters">
                        {this.state.appliedFilterVal.map((i, j) => (
                          <li>
                            <span className="latoBold" style={{ textTransform: 'capitalize' }}>{i.label}</span>
                            <a
                              href="javascript:;"
                              onClick={() =>
                                this.RemoveSingleFilter(
                                  i,
                                  j,
                                  this.state.FiltersData.max_price
                                )
                              }
                            ></a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ) : (
                    <p
                      className="makeFlex spaceBetween end"
                      style={{ justifyContent: "flex-start" }}
                    >
                      <span className="font20 blackText">
                        Select Filters
                      </span>
                    </p>
                  )}

                  <div
                    className="filterRow"
                    id="hlistpg_fr_star_category"
                    style={{ marginBottom: 30 }}
                  >
                    <div className="latoBold font16 blackText appendBottom15 makeFlexNew hrtlCenter">
                      Price
                    </div>
                    <InputRange
                      maxValue={parseFloat(this.state.FiltersData.max_price ?? 0)}
                      minValue={parseFloat(this.state.FiltersData.min_price ?? 0)}
                      value={this.state.valuePrice}
                      onChange={(value) =>
                        this.setState({ valuePrice: value })
                      }
                      onChangeComplete={(value) => this.changePrice(value)}
                    />
                    <span className="minValue">
                      <FontAwesomeIcon
                        icon={faEuroSign}
                        style={{ fontSize: "13px", color: "#555" }}
                      ></FontAwesomeIcon>{" "}
                      {this.state.valuePrice.min}
                    </span>
                    <span className="maxValue">
                      <FontAwesomeIcon
                        icon={faEuroSign}
                        style={{ fontSize: "13px", color: "#555" }}
                      ></FontAwesomeIcon>{" "}
                      {this.state.valuePrice.max}
                    </span>
                  </div>

                  <div
                    className="filterRow"
                    id="hlistpg_fr_star_category"
                    style={{ marginBottom: 30, marginTop: 50 }}
                  >
                    <div className="latoBold font16 blackText appendBottom15 makeFlexNew hrtlCenter">
                      Duration (In Nights)
                    </div>
                    <InputRange
                      maxValue={parseInt(this.state.FiltersData.max_night ?? 0)}
                      minValue={parseInt(this.state.FiltersData.min_night ?? 0)}
                      value={this.state.durationFilterValue}
                      onChange={(value) =>
                        this.setState({ durationFilterValue: value })
                      }
                      onChangeComplete={(value) => this.changeDuration(value)}
                    />
                    <span className="minValue">
                      {this.state.durationFilterValue.min}N
                    </span>
                    <span className="maxValue">
                      {this.state.durationFilterValue.max}N
                    </span>
                  </div>
                  {this.state.FiltersData?.package_category && Object.keys(this.state.FiltersData.package_category).length > 0 &&
                    <div className="filterRow" id="hlistpg_fr_star_category"
                      style={{ marginTop: 50 }}>
                      <div className="latoBold font16 blackText appendBottom15 makeFlex hrtlCenter">
                        Category
                      </div>
                      <div className="list-group list-group-flush">
                        {
                          Object.entries(this.state.FiltersData?.package_category || {})
                            .map(([_, { package_name, id, count }], index) =>
                              <label key={index} className="list-group-item ps-0">
                                <input className="form-check-input text-capitalize me-1" type="checkbox" value={id} checked={this.state.selectedCategories.includes(id)} onChange={() => this.handleCheckboxChange(id)} />
                                {`${package_name} (${count})`}
                              </label>
                            )
                        }
                      </div>
                    </div>
                  }
                </div>
              )}

              <div className="listingWrap">
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                  <span style={{ color: "#55575b", paddingTop: 0 }} >
                    <b>
                      {
                        Array.isArray(this.state.packageData) ?
                          this.state.packageData.filter((i) => i != "no_package").length : 0
                      } Results
                    </b>
                  </span>
                  {this.state.packageData !== null && this.state.packageData != "no_package" && (
                    <div
                      className="hsw_viewMap_content hsw_viewMap"
                      style={{ display: "flex", paddingTop: 0 }}
                    >
                      <span
                        className="latoBold"
                        style={{ color: "#55575b", fontWeight: "600 !important" }}
                      >
                        Sort By:&nbsp;
                      </span>
                      <div className="customSelect">
                        <span
                          className="customSelectTitle  latoBold"
                          style={{ color: "#008cff" }}
                          onClick={this.showSorting}
                        >
                          {this.state.sortingSelect}
                        </span>
                        {this.state.isDropdownOpen && (
                          <ul className="customSelectOptions latoBold" style={{ left: '35%', top: '23px' }}>
                            {SortArr.map((item, index) => (
                              <li
                                className={
                                  this.state.sortingSelect == item.name
                                    ? "selectedActiveSort"
                                    : ""
                                }
                                key={index}
                                onClick={() => this.handleSortingChange(item)}
                              >
                                {item.name}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                  )}
                </div>
                <div className="container container-custom margin_30_95">
                  {this.state.packageData === null ? (
                    <>
                      {
                        Array.from({ length: 3 }, (_, index) => index).map((_, index) => <HotelListSkeleton key={index} />)
                      }
                    </>
                  ) : this.state.packageData == "no_package" || this.state.packageData.length === 0 ? (
                    <EmptyRowComponent />
                  ) : (
                    <>
                      {this.state.packageData.map((packageData, index) =>
                        <TourPackageList
                          key={index}
                          tour_data={packageData}
                          dateSelected={this.state.selectPackageDayNew}
                          defaultZonevalPackageVal={this.state.defaultZonevalPackage}
                        />
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <TawkToWidget />
      </React.Fragment>
    );
  }
}
